import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, User, Calendar, Clock } from 'lucide-react';
import '../../../assets/styles/customer/Publicblogdetail.css';
import MyLayout from '../../../layouts/customer/MyLayout';

/* ── Mock Data (same as PublicBlog — in real app from API) ── */
const BLOG_POSTS = [
  {
    id: 1,
    title: 'First Blog Post',
    slug: 'first-blog-post',
    excerpt: 'testing description of the blog',
    content: 'testing content of the blog, testing content of the blog, testing content of the blog, testing content of the blog, testing content of the blog',
    author: 'Hamza',
    date: 'April 4, 2026',
    tags: ['dairy', 'farming', 'milk'],
    coverImage: null,
    readTime: '1 min read',
  },
  {
    id: 2,
    title: 'The Future of Milk Distribution',
    slug: 'future-of-milk-distribution',
    excerpt: 'How technology is transforming Pakistan\'s dairy supply chain.',
    content: 'Full content about milk distribution and how QR-based systems are revolutionizing the way farmers, distributors, and consumers interact with the dairy supply chain.',
    author: 'Ahmed',
    date: 'March 28, 2026',
    tags: ['dairy', 'technology'],
    coverImage: null,
    readTime: '3 min read',
  },
];

/* ── Navbar ── */
// const PublicNavbar = () => {
//   const navigate = useNavigate();
//   return (
//     <nav className="pblogd-navbar">
//       <div className="pblogd-navbar__inner">
//         <div className="pblogd-navbar__brand" onClick={() => navigate('/')}>
//           <div className="pblogd-navbar__logo">🥛</div>
//           <span className="pblogd-navbar__name">MilkFlow</span>
//         </div>
//         <ul className="pblogd-navbar__links">
//           <li onClick={() => navigate('/distributors')}>Distributors</li>
//           <li onClick={() => navigate('/pricing')}>Pricing</li>
//           <li onClick={() => navigate('/about')}>About</li>
//           <li onClick={() => navigate('/contact')}>Contact</li>
//           <li className="pblogd-navbar__link--active" onClick={() => navigate('/blog')}>Blog</li>
//         </ul>
//         <div className="pblogd-navbar__actions">
//           <button className="pblogd-navbar__login" onClick={() => navigate('/login')}>Login</button>
//           <button className="pblogd-navbar__cta" onClick={() => navigate('/become-distributor')}>Become a Distributor</button>
//         </div>
//       </div>
//     </nav>
//   );
// };

/* ── Footer ── */
// const PublicFooter = () => {
//   const navigate = useNavigate();
//   return (
//     <footer className="pblogd-footer">
//       <Container>
//         <div className="pblogd-footer__grid">
//           <div>
//             <div className="pblogd-footer__brand">
//               <span className="pblogd-footer__logo">🥛</span>
//               <span className="pblogd-footer__name">MilkFlow</span>
//             </div>
//             <p className="pblogd-footer__tagline">Simplifying dairy delivery management for Pakistan's local milk supply chain.</p>
//           </div>
//           <div>
//             <p className="pblogd-footer__col-title">Product</p>
//             <ul className="pblogd-footer__list">
//               <li onClick={() => navigate('/pricing')}>Pricing</li>
//               <li onClick={() => navigate('/about')}>About</li>
//               <li onClick={() => navigate('/contact')}>Contact</li>
//             </ul>
//           </div>
//           <div>
//             <p className="pblogd-footer__col-title">For Users</p>
//             <ul className="pblogd-footer__list">
//               <li onClick={() => navigate('/signup')}>Customer Signup</li>
//               <li onClick={() => navigate('/login')}>Login</li>
//             </ul>
//           </div>
//           <div>
//             <p className="pblogd-footer__col-title">For Distributors</p>
//             <ul className="pblogd-footer__list">
//               <li onClick={() => navigate('/become-distributor')}>Become a Distributor</li>
//               <li onClick={() => navigate('/distributor-login')}>Distributor Login</li>
//             </ul>
//           </div>
//         </div>
//         <div className="pblogd-footer__bottom">
//           <p>© 2024 MilkFlow. All rights reserved.</p>
//         </div>
//       </Container>
//     </footer>
//   );
// };

/* ══════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════ */
const PublicBlogDetail = () => {
  const { slug }   = useParams();
  const navigate   = useNavigate();
  const post       = BLOG_POSTS.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="pblogd-root">
        {/* <PublicNavbar /> */}
        <div className="pblogd-notfound">
          <h2>Post not found</h2>
          <button className="pblogd-back-btn" onClick={() => navigate('/blogs')}>
            <ArrowLeft size={16} /> Back to Blogs
          </button>
        </div>
        {/* <PublicFooter /> */}
      </div>
    );
  }

  return (
    <MyLayout>
    <div className="pblogd-root">
      {/* <PublicNavbar /> */}

      <main className="pblogd-main">
        <Container>
          <div className="pblogd-article">

            {/* Back */}
            <button className="pblogd-back-btn" onClick={() => navigate('/blog')}>
              <ArrowLeft size={15} /> Back to Blogs
            </button>

            {/* Tags */}
            <div className="pblogd-tags">
              {post.tags.map(t => (
                <span key={t} className="pblogd-tag">{t}</span>
              ))}
            </div>

            {/* Title */}
            <h1 className="pblogd-title">{post.title}</h1>

            {/* Excerpt */}
            <p className="pblogd-excerpt">{post.excerpt}</p>

            {/* Meta */}
            <div className="pblogd-meta">
              <span className="pblogd-meta__item">
                <User size={14} /> {post.author}
              </span>
              <span className="pblogd-meta__dot">·</span>
              <span className="pblogd-meta__item">
                <Calendar size={14} /> {post.date}
              </span>
              <span className="pblogd-meta__dot">·</span>
              <span className="pblogd-meta__item">
                <Clock size={14} /> {post.readTime}
              </span>
            </div>

            {/* Divider */}
            <div className="pblogd-divider" />

            {/* Cover Image */}
            {post.coverImage && (
              <div className="pblogd-cover">
                <img src={post.coverImage} alt={post.title} className="pblogd-cover__img" />
              </div>
            )}

            {/* Content */}
            <div className="pblogd-content">
              <p>{post.content}</p>
            </div>

          </div>
        </Container>
      </main>

      {/* <PublicFooter /> */}
    </div>
    </MyLayout>
  );
};

export default PublicBlogDetail;